import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'access-denied',
    templateUrl: './access.denied.component.html',
    styleUrls: ['./access.denied.css']
})
export class AccessDeniedComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    }
}
